/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Tracking_RetryInputs */

const vi_carrier_tracking_retry = /** @type {(inputs: Carrier_Tracking_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

/**

* @param {Carrier_Tracking_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_tracking_retry = /** @type {((inputs?: Carrier_Tracking_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Tracking_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_tracking_retry(inputs)
});